import { Switch, Route, Router as WouterRouter, useLocation } from "wouter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { useEffect } from "react";
import NotFound from "@/pages/not-found";
import BookingPage from "@/pages/BookingPage";
import ManagePage from "@/pages/ManagePage";
import { createBookingTheme } from "@/lib/theme";

const queryClient = new QueryClient();

// Explicit opt-in entry point for internal demo/preview testing. Redirects
// to the root booking flow with `?demo=true` so BookingPage's single
// isDemo check (query-param driven) stays the source of truth.
function DemoBookingPage() {
  const [, setLocation] = useLocation();
  useEffect(() => {
    setLocation("/?demo=true", { replace: true });
  }, [setLocation]);
  return null;
}

function Router() {
  return (
    <Switch>
      <Route path="/" component={BookingPage} />
      <Route path="/demo" component={DemoBookingPage} />
      <Route path="/manage" component={ManagePage} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ThemeProvider theme={createBookingTheme()}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <WouterRouter base={import.meta.env.BASE_URL.replace(/\/$/, "")}>
          <Router />
        </WouterRouter>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
